import { Link, Navigate } from 'react-router-dom';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import { useAuth } from '../../../context/AuthContext';
import { ForgotPasswordForm } from '../../../forms/ForgotPassword/ForgotPasswordForm';
import { Values } from '../../../forms/ForgotPassword/ForgotPasswordForm.types';
import logger from '../../../utils/logger';
import { useLoading } from '../../../context/loadingContext';

/**
 * A component for the forgot password page
 */
export const ForgotPasswordPage = () => {
  const { isAuthenticated } = useAuth();
  const { startLoading, stopLoading } = useLoading();
  /**
   * Handles forgot password form submit.
   * Sends forgot password API request.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    logger.i(values);
    try {
      startLoading();
      const response = await http.apiPost({ url: apiUrl.FORGOT_PASSWORD, data: values });
      logger.i(response);
      stopLoading();
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (isAuthenticated) return <Navigate to="/dashboard" />;

  return (
    <div className="mx-auto min-h-full h-screen flex items-center justify-center max-w-md py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl w-full space-y-8">
        <div className="mb-10">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Forgot password
          </h2>
        </div>
        <p className="text-center text-sm text-gray-600">
          Enter your email for which you want to enter a password reset request.
        </p>
        <ForgotPasswordForm onSubmit={handleSubmit} />
        <p className="text-center text-sm text-gray-600">
          <Link to="/signin" className="font-medium text-blue-600 hover:text-blue-500">
            Back to sign in.
          </Link>
        </p>
      </div>
    </div>
  );
};
